/**
 * Admin theme – Vuexy-style palette (from primaryColorConfig / colorSchemes).
 * MUI 5 compatible; used only for admin routes.
 */
import { createTheme } from '@mui/material/styles';

// Vuexy primary-1 and palette from colorSchemes (light)
const adminTheme = createTheme({
  palette: {
    primary: {
      main: '#7367F0',
      light: '#8F85F3',
      dark: '#675DD8',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#808390',
      light: '#999CA6',
      dark: '#737682',
      contrastText: '#FFF',
    },
    error: {
      main: '#FF4C51',
      light: '#FF7074',
      dark: '#E64449',
      contrastText: '#FFF',
    },
    warning: {
      main: '#FF9F43',
      light: '#FFB269',
      dark: '#E68F3C',
      contrastText: '#FFF',
    },
    info: {
      main: '#00BAD1',
      light: '#33C8DA',
      dark: '#00A7BC',
      contrastText: '#FFF',
    },
    success: {
      main: '#28C76F',
      light: '#53D28C',
      dark: '#24B364',
      contrastText: '#FFF',
    },
    background: {
      default: '#F8F7FA',
      paper: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", "Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(0,0,0,0.08)',
        },
      },
    },
  },
});

export default adminTheme;
